// src/context/CartContext.jsx
import React, { createContext, useContext, useReducer } from "react";

const CartContext = createContext();
const CartDispatchContext = createContext();

const initialState = {
  cartItems: [],
  totalPrice: 0,
};

function cartReducer(state, action) {
  switch (action.type) {
    case "ADD_TO_CART": {
      const existingItem = state.cartItems.find(
        (item) => item._id === action.payload._id
      );

      let updatedItems;
      if (existingItem) {
        updatedItems = state.cartItems.map((item) =>
          item._id === action.payload._id
            ? { ...item, qty: item.qty + 1 }
            : item
        );
      } else {
        updatedItems = [...state.cartItems, { ...action.payload, qty: 1 }];
      }

      const total = updatedItems.reduce(
        (sum, item) => sum + item.price * item.qty,
        0
      );

      return { cartItems: updatedItems, totalPrice: total };
    }

    case "REMOVE_FROM_CART": {
      const updatedItems = state.cartItems.filter(
        (item) => item._id !== action.payload
      );
      const total = updatedItems.reduce(
        (sum, item) => sum + item.price * item.qty,
        0
      );
      return { cartItems: updatedItems, totalPrice: total };
    }

    case "CLEAR_CART":
      return initialState;

    default:
      return state;
  }
}

export function CartProvider({ children }) {
  const [state, dispatch] = useReducer(cartReducer, initialState);

  return (
    <CartContext.Provider value={state}>
      <CartDispatchContext.Provider
        value={{
          addToCart: (item) => dispatch({ type: "ADD_TO_CART", payload: item }),
          removeFromCart: (id) =>
            dispatch({ type: "REMOVE_FROM_CART", payload: id }),
          clearCart: () => dispatch({ type: "CLEAR_CART" }),
        }}
      >
        {children}
      </CartDispatchContext.Provider>
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
export const useCartDispatch = () => useContext(CartDispatchContext);
